import useDevice from 'hooks/DesktopDevice.hook';
import React from 'react';
import { Box, Typography } from 'styles';

const ViewPlansPage: React.FC = () => {
  const { isDesktop } = useDevice();

  return (
    <Box sx={{ width: '100%', height: '100px' }}>
      <Typography
        variant={!!isDesktop ? 'title2' : 'title4'}
        sx={{ color: 'primary3.main' }}
      >
        Page is under construction
      </Typography>
    </Box>

  )
}

export default ViewPlansPage;
